import React, {useCallback} from "react";
import styles from "./HeaderNew.module.scss";
import {cn, RouteDictionary} from "../../../utils";
import Container from "../Container";
import {Button, CustomLink, Hamburger, Image, TertiaryButton} from "../../common";
import {LogoImage} from "../../common/images/types";
import {LogoType} from "../../common/images/types/LogoImage";
import {Chat} from "../../user/profile/Chat";
import NotificationLink from "../../common/buttons/decorators/NotificationLink";
import ProfileMenu from "../../user/profile/ProfileMenu";
import {useProfileData, useToggle} from "../../../hooks";
import {TertiaryButtonColor} from "../../common/buttons/decorators/TertiaryButton/TertiaryButton";
import {useWindowWidth} from "../../pages/detailed-project/hooks";
import cross from "../../../assets/images/svg/profile-menu-cross.svg";
import MobileNavigation from "../MobileNavigation";
import {HamburgerColor} from "../../common/utils/Hamburger/Hamburger";

const navigationItems = [
  {
    to: RouteDictionary.MY_MONEY,
    text: "Мои Деньги",
  },
  {
    to: RouteDictionary.PRIMARY_MARKET,
    text: "Все проекты",
  },
  {
    to: RouteDictionary.MY_PROJECTS,
    text: "Мои инвестиции",
  },
  {
    to: RouteDictionary.TRANSACTIONS,
    text: "Транзакции",
  },
];

const moneyLinks = [
  {
    to: RouteDictionary.DEPOSIT,
    color: TertiaryButtonColor.GREEN,
    text: "Пополнить",
  },
  {
    to: RouteDictionary.WITHDRAW,
    color: TertiaryButtonColor.GRAY,
    text: "Вывести",
  },
];

export const HeaderLender = () => {
  const profileData = useProfileData();
  const handleClick = useCallback(() => {
    window.scrollTo(0, 0);
  }, []);
  const isMobile = useWindowWidth(992);
  const [active, toggle, setActive] = useToggle();
  const handleWrapperClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget) {
      setActive(false);
    }
  };

  const headerWithoutWrapper =  <header className={styles.header}>
    <Container>
      <div className={styles.logo__container}>
        {isMobile && <div>
          {active ? <Image src={cross} onClick={toggle} className={styles.logo__container__cross}/> :
            <Hamburger onClick={toggle} rows={3} color={HamburgerColor.GREEN}/>}
        </div>}
        {!isMobile && <CustomLink to={RouteDictionary.INDEX}>
          <LogoImage className={styles.logo} type={LogoType.LOGO_TEXT}/>
        </CustomLink>}
        <div className={styles.user__menu}>
          <div className={styles.chat}>
            <Chat/>
          </div>
          <div className={styles.notifications}>
            <NotificationLink/>
            {profileData.newNotificationCount > 0 &&
                <span className={styles.notifications__count}>{profileData.newNotificationCount}</span>}
          </div>
        </div>
        <ProfileMenu clickable={!isMobile}/>
      </div>
      {active && isMobile && <div className={styles.mobile__nav__money}>
        {moneyLinks.map((link, index) => (
          <TertiaryButton color={link.color} key={index} expanded>
            <CustomLink
              to={link.to}
            >
              {link.text}
            </CustomLink>
          </TertiaryButton>
        ))}
      </div>
      }
      <nav className={styles.nav}>
        <div className={styles.nav__left}>
          <ul className={styles.nav__list}>
            {navigationItems.map((item, index) => (
              <li key={index} className={styles.nav__element}>
                <CustomLink
                  onClick={handleClick}
                  className={styles.nav__link}
                  to={item.to}
                >
                  <span>{item.text}</span>
                </CustomLink>
              </li>
            ))}
          </ul>
        </div>

        <div className={styles.nav__right}>
          <ul className={styles.nav__money__list}>
            <li className={styles.nav__element}>
              <Button className={styles.nav__element__button}>
                <CustomLink
                  className={styles.nav__money__link}
                  to={RouteDictionary.DEPOSIT}
                >
                    Пополнить
                </CustomLink>
              </Button>
            </li>
            <li className={styles.nav__element}>
              <Button className={cn(styles.nav__element__button, styles.nav__element__buttonReverse)}>
                <CustomLink
                  className={styles.nav__money__link}
                  to={RouteDictionary.WITHDRAW}
                >
                  Вывести
                </CustomLink>
              </Button>
            </li>
          </ul>
        </div>
      </nav>
      <MobileNavigation active={active} onNavigated={() => setActive(false)} />
    </Container>
  </header>;

  return isMobile ? <div className={`${styles.wrapper} ${active ? styles.wrapper__active : ''}`} onClick={handleWrapperClick}>
    {headerWithoutWrapper}
  </div> : headerWithoutWrapper;
};